import { useState } from "react";

export default function AlertList() {
    const [open, setOpen] = useState(false);

    return (
        <div className="styles_alertList__AQzMl">
            <div className={open ? 'styles_readMoreWrapper__cQ0iz styles_isReadMore__uCEoc' : 'styles_readMoreWrapper__cQ0iz'}>
                <div
                    className="MuiCollapse-root"
                    style={{
                        minHeight: 40,
                        height: open ? "auto" : "80px",
                        overflow: "hidden",
                        transition: "max-height .3s ease"
                    }}
                >
                    <div className="MuiCollapse-wrapper">
                        <div className="MuiCollapse-wrapperInner">

                            {/* item 1 */}
                            <div className="styles_attentionItem__7nBC5 styles_isRemoveStyle__yzowF">
                                <div className="styles_attentionContent__Y3b_H">
                                    <div className="styles_attentionIcon__Qctnh">
                                        <img src="https://cdn-web-next.thuocsi.vn/images/cart/info_icon.svg" alt="cart alert" />
                                    </div>
                                    <div className="styles_attentionText__Jg6dB">
                                        Giỏ hàng có sản phẩm khuyến mãi. Sau khi thanh toán, đơn hàng sẽ không thể chỉnh sửa được
                                    </div>
                                </div>
                            </div>

                            {/* item 2 */}
                            <div className="styles_attentionItem__7nBC5 styles_isRemoveStyle__yzowF">
                                <div className="styles_attentionContent__Y3b_H">
                                    <div className="styles_attentionIcon__Qctnh">
                                        <img src="https://cdn-web-next.thuocsi.vn/images/cart/active_important_icon.svg" alt="cart alert" />
                                    </div>
                                    <div className="styles_attentionText__Jg6dB">
                                        Nhấn vào biểu tượng ngôi sao để đánh dấu sản phẩm quan trọng (giới hạn 20% tổng số sản phẩm, 1 sản phẩm đặt nhiều cái cũng tính là 1)
                                    </div>
                                </div>
                            </div>

                            {/* item 3 */}
                            <div className="styles_attentionItem__7nBC5 styles_isRemoveStyle__yzowF">
                                <div className="styles_attentionContent__Y3b_H">
                                    <div className="styles_attentionIcon__Qctnh">
                                        <img alt="cart alert" src="https://cdn-web-next.thuocsi.vn/images/cart/document_icon.svg" />
                                    </div>
                                    <div className="styles_attentionText__Jg6dB">
                                        Chỉ xuất hóa đơn cho sản phẩm có tag "Hóa đơn nhanh"
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* nút toggle */}
                <div
                    role="button"
                    className="styles_readMoreAction__XK6Gj"
                    onClick={() => setOpen(prev => !prev)}
                >
                    <p className="styles_textLink__XTo35 !mb-0">
                        {open ? "Thu gọn lưu ý" : "Hiện tất cả lưu ý"}
                    </p>
                    <div className="styles_icon__h9aEM">
                        <img
                            src="https://cdn-web-next.thuocsi.vn/images/cart/open_icon.svg"
                            alt="open icon"
                            style={{
                                transform: open ? "rotate(0deg)" : "rotate(0deg)",
                                transition: ".2s"
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
